module.exports = __webpack_public_path__ + "assets/img/pay_confirmation4d71c2e4.svg";